import { segment, track, getPageSource } from '@mc/track-event'

export const trackPurchaseClick = ({
  slug,
  isLive,
  action,
  href,
}: {
  slug: string
  isLive: boolean
  action: string
  href: string
}) =>
  track(segment.EventTypes.PURCHASE_CLICK, {
    category: 'hero',
    location: 'hero',
    action,
    href,
    page_type: 'class-page',
    class_type: 'camp',
    class: slug,
    instructor_coming_soon: !isLive,
    page_source: getPageSource(),
  })

export const trackAllImmersionsLink = (
  ctaText: string,
  slug: string,
  comingSoon: boolean,
) =>
  track(segment.EventTypes.COURSE_MARKETING_CLICK, {
    category: 'hero',
    location: 'hero',
    action: ctaText,
    page_type: 'class-page',
    class_type: 'camp',
    class: slug,
    instructor_coming_soon: comingSoon,
  })

export const trackCampHeroTrailerClick = (
  slug: string,
  isLive: boolean,
  contentId: string,
) => {
  track(segment.EventTypes.COURSE_MARKETING_CLICK, {
    category: 'hero',
    location: 'hero',
    action: 'Watch Trailer',
    page_type: 'class-page',
    class_type: 'camp',
    content_type: 'Camp Trailer',
    content_id: contentId,
    class: slug,
    instructor_coming_soon: !isLive,
  })
}

const baseVideoPlayerEventsAttributes = {
  category: 'hero',
  location: 'hero',
  page_type: 'class-page',
  class_type: 'camp',
  content_type: 'Camp Trailer',
}

export const getVideoPlayerEventAttributes = (
  slug: string,
  isLive: boolean,
  contentId: string,
) => ({
  ...baseVideoPlayerEventsAttributes,
  class: slug,
  instructor_coming_soon: !isLive,
  content_id: contentId,
})
